import * as React from "react"
import { App } from "./app"
import { Assert } from "./PADebug"

///////////////   PriceSettingsView  ////////////////

/* PriceSettingsView displays settings for the prices being shown, like purchasing taxes, factory price versus reccommended price etc. */

export interface PriceSettingsViewVm  {
    app: App
}

export interface PriceSettingsViewStateVm {
    stage: string
}

export class PriceSettingsView extends React.Component<PriceSettingsViewVm, PriceSettingsViewStateVm> {
    constructor(props: PriceSettingsViewVm) {
        super(props)
        this.m_hoveredRadioIndex = -1
    }

    // 
    state = {
        stage: "initial"
    }
    
    // 
    componentWillMount() {
        this.props.app.GetCore().ConnectPriceSettingsView(this)
    }

    // 
    OnClickRadio01() {
        this.m_hoveredRadioIndex = -1
        this.props.app.setState({ cathegoricSearch: false })
        this.forceUpdate()
    }

    // 
    OnClickRadio02() {
        this.m_hoveredRadioIndex = -1
        this.props.app.setState({ cathegoricSearch: true })
        this.forceUpdate()
    }
    
    // 
    render() {
        
        // Checks if the user wants to overwrite a saved project with the identical name
        if (this.state.stage == "saveSettingsQuestion") {
         
            return <div style={{ display: "flex", flexDirection: "row" }}>

            </div>
        }

        const core = this.props.app.GetCore() 

        const margin_Left = "17px"
        const margin_Left_long = "50px"
        const margin_Mid = "13px"
        const checkedPos = "0px 0px"
        const uncheckedPos = "-25px 0px"
        const checkedPosGrey = "0px -73px"
        const uncheckedPosGrey = "-25px -73px"
        const checkedPosRadio = "0px -36px"
        const uncheckedPosRadio = "-25px -36px"

        const checkWidth = "25px"
        const checkHeight = "25px"
        const itemHeight = "30px"
        const radioTopMargin = "10px"
        const marginTextTop = "5px"

        const bgFile = "url(images/searchSettingsGraphics.png)"

        var flags = this.props.app.GetCore().GetPriceFlags()
        var radioPos = this.props.app.GetCore().GetPriceRadio()

        var imgPos_noPrice = (radioPos == 0) ? checkedPosRadio : uncheckedPosRadio
        var imgPos_basePrice = (radioPos == 1) ? checkedPosRadio : uncheckedPosRadio

        var imgPos_rabatt = ((flags & 1) != 0) ? checkedPos : uncheckedPos
        var imgPos_paslag = ((flags & 2) != 0) ? checkedPos : uncheckedPos
        var subColor = "black"

        if (radioPos != 1) {
            imgPos_rabatt = ((flags & 1) != 0) ? checkedPosGrey : uncheckedPosGrey
            imgPos_paslag = ((flags & 2) != 0) ? checkedPosGrey : uncheckedPosGrey
            subColor = "#888888"
        }

        var imgPos_veilPris = (radioPos == 2) ? checkedPosRadio : uncheckedPosRadio
        var imgPos_factory = (radioPos == 3) ? checkedPosRadio : uncheckedPosRadio

        var imgPos_mva = ((flags & 4) != 0) ? checkedPos : uncheckedPos
        
        return <div>
            <h2 style={{ marginTop: "20px", marginLeft: "20px" }}>Prisvalg:</h2>

            <div onClick={(e) => this.OnCheckClick("noPrice")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, topMargin: radioTopMargin, backgroundPosition: imgPos_noPrice, width: checkWidth, height: checkHeight, cursor: "pointer" }}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor: "pointer" }}>Ingen priser
                </div>
            </div>

            <div onClick={(e) => this.OnCheckClick("base")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, topMargin: radioTopMargin, backgroundPosition: imgPos_basePrice, width: checkWidth, height: checkHeight, cursor: "pointer" }}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor: "pointer" }}>Grunn-/prosjektpriser
                </div>
            </div>

            {/*  // These two options for price settings is commented out because they don't currently have any use.

            <div onClick={(e) => this.OnCheckClick("rabatt")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left_long }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_rabatt, width: checkWidth, height: checkHeight, cursor: "pointer" }} ></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor: "pointer", color: subColor }}>Rabatt
                </div>
            </div>

            <div onClick={(e) => this.OnCheckClick("paslag")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left_long }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_paslag, width: checkWidth, height: checkHeight, cursor: "pointer" }}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor: "pointer", color: subColor }}>Påslag
                </div>
            </div>
            */}

            <div onClick={(e) => this.OnCheckClick("veil")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, topMargin: radioTopMargin, backgroundPosition: imgPos_veilPris, width: checkWidth, height: checkHeight, cursor: "pointer" }}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor: "pointer" }}>Veil. pris
                </div>
            </div>
            
            <div onClick={(e) => this.OnCheckClick("factory")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, topMargin: radioTopMargin, backgroundPosition: imgPos_factory, width: checkWidth, height: checkHeight, cursor: "pointer" }}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor: "pointer" }}>Fabrikk pris
                </div>
            </div>
            
            <div onClick={(e) => this.OnCheckClick("mva")} style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, topMargin: radioTopMargin, backgroundPosition: imgPos_mva, width: checkWidth, height: checkHeight, cursor: "pointer" }}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop, cursor:"pointer" }}>MVA   sats:  [25%]</div>
            </div>
            
        </div>
    }

    OnCheckClick(clickedItem: string) {
        var previousFlags = this.props.app.GetCore().GetPriceFlags()
        var previousRadioPos = this.props.app.GetCore().GetPriceRadio()

        if (clickedItem == "noPrice") {
            previousRadioPos = 0
        }

        if (clickedItem == "base") {
            previousRadioPos = 1
        }

        if (clickedItem == "rabatt") {
            if ((previousFlags & 1) != 0) {
                previousFlags = previousFlags & (2 | 4)
            }
            else {
                previousFlags = previousFlags | 1
            }
        }

        if (clickedItem == "paslag") {
            if ((previousFlags & 2) != 0) {
                previousFlags = previousFlags & (1 | 4)
            }
            else {
                previousFlags = previousFlags | 2
            }
        }

        if (clickedItem == "veil") {
            previousRadioPos = 2
        }

        if (clickedItem == "factory") {
            previousRadioPos = 3
        }

        if (clickedItem == "mva") {
            if ((previousFlags & 4) != 0) {
                previousFlags = previousFlags & (1 | 2)
            }
            else {
                previousFlags = previousFlags | 4
            }
        }
        
        this.props.app.GetCore().SetPriceFlags(previousFlags)
        this.props.app.GetCore().SetPriceRadio(previousRadioPos)
        this.props.app.forceUpdate()
    }

    private m_hoveredRadioIndex: number
}


// WEBPACK FOOTER //
// ./client/view/PriceSettingsView.tsx